<div class="view-container">
    <mat-card>
        <mat-card-content>
            <product-catalog-list
                [companyIdFilter]="companyIdFilter"
                [brandIdFilter]="brandIdFilter"
                [productClassificationIdFilter]="productClassificationIdFilter"
                [productTypeIdFilter]="productTypeIdFilter"
                [productStateFilter]="productStateFilter"
                [productRangeIdFilter]="productRangeIdFilter"
                [productSpecificationSelectedIds]="productSpecificationSelectedIds"
                [searchTerm]="searchTerm"
                (onFilterCompanyId)="onFilterCompanyId($event)"
                (onFilterBrandId)="onFilterBrandId($event)"
                (onFilterProductClassificationId)="onFilterProductClassificationId($event)"
                (onFilterProductTypeId)="onFilterProductTypeId($event)"
                (onFilterProductState)="onFilterProductState($event)"
                (onFilterProductRangeId)="onFilterProductRange($event)"
                (onFilterProductSpecificationSelectedIds)="onFilterProductSpecificationSelectedIds($event)"
                (onProductSelected)="onProductSelected($event)"
                (onSearchTermChanged)="onSearchTermChanged($event)"
                [isCatalog]="true"
                [editProductOnClick]="true">
            </product-catalog-list>
        </mat-card-content>
    </mat-card>
</div>

